// DS2 Input: the text field. isInvalid: a red line. forceUpper: the value turned to upper case as typed. suffix: the
// unit, inside the box at the right, as the Numeric's. disabled is also read-only. Delete does not reach the parents
// (a table's row shortcuts). Label, helper text and error: FormField.
import cx from "classnames";
import type { CSSProperties, InputHTMLAttributes, Ref } from "react";
import styles from "./Input.module.css";

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  isInvalid?: boolean;
  forceUpper?: boolean;
  suffix?: string;
  ref?: Ref<HTMLInputElement>;
};

export function Input({
  isInvalid,
  forceUpper,
  suffix,
  className,
  type = "text",
  autoComplete = "off",
  spellCheck = false,
  disabled,
  readOnly,
  onChange,
  onKeyDown,
  ref,
  ...props
}: InputProps) {
  const input = (
    <input
      ref={ref}
      {...props}
      type={type}
      autoComplete={autoComplete}
      spellCheck={spellCheck}
      disabled={disabled}
      readOnly={disabled || readOnly}
      aria-invalid={isInvalid}
      className={cx(styles.input, isInvalid && styles.invalid, suffix && styles.withSuffix, className)}
      onChange={(event) => {
        if (forceUpper) event.target.value = event.target.value.toUpperCase();
        onChange?.(event);
      }}
      onKeyDown={(event) => {
        if (event.key === "Delete") event.stopPropagation();
        onKeyDown?.(event);
      }}
    />
  );
  if (!suffix) return input;

  return (
    <span className={styles.affixed} style={{ "--suffix-length": suffix.length } as CSSProperties}>
      {input}
      <span className={cx(styles.suffix, disabled && styles.suffixDisabled)}>{suffix}</span>
    </span>
  );
}
